import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { TriviaService, TriviaGameListView, TriviaGameFormData } from '../_services/trivia-service';
import { ManagementComponentBase, ColumnProperty } from '../_shared/base.management.component';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../_services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { JWTTokenService } from '../_services/jwtToken.service';

@Component({
  templateUrl: '../_shared/base.management.component.html',
  styleUrls: ['../_shared/base.management.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TriviaManagementComponent extends ManagementComponentBase<TriviaGameListView, TriviaGameFormData> {
  constructor(
    triviaService: TriviaService,
    router: Router,
    dialogService: DialogService,
    viewRef: ViewContainerRef,
    httpClient: HttpClient,
    userService: UserService,
    spinner: NgxSpinnerService,
    jwtTokenService: JWTTokenService
  ) {
    super(triviaService, router, dialogService, viewRef, httpClient, userService, spinner, jwtTokenService);

    const newColumn: ColumnProperty = { propertyName: 'gamesPlayed', sortable: true, headerName: 'Games Played', dataName: 'gamesPlayed' };
    this.additionalColumns.push(newColumn);
  }

  protected GetRouteName(): string {
    return 'trivia';
  }
}

